import BoldText from '@/components/BoldText';
import IconButton from '@/components/IconButton';
import { timelineIcons } from '@/components/Icons/TimelineIcons';
import { IParamsApi } from '@/types/apis/params';
import { memo } from 'react';

interface IProps {
  setSelectedIcon: React.Dispatch<React.SetStateAction<IParamsApi.IDataSettingTimelineIcon | undefined>>;
  selectedIcon?: IParamsApi.IDataSettingTimelineIcon;
}

function DefaultIconTab({ setSelectedIcon, selectedIcon }: IProps) {
  const checkIfSelected = (id: number) => {
    return id === selectedIcon?.iconId;
  };

  return (
    <div className="d-flex flex-column">
      {timelineIcons.map((item) => (
        <div key={item.id}>
          <div className="mt-8">
            <BoldText>{item.title}</BoldText>
          </div>
          <div className="editor-icon-container mt-8" style={{ gap: 10 }}>
            {item.icons.map((icon) => (
              <IconButton
                selected={checkIfSelected(+icon.id)}
                onClick={() => setSelectedIcon({ iconId: +icon.id })}
                key={icon.id}
              >
                {icon.icon}
              </IconButton>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default memo(DefaultIconTab);
